import { SYSTEM_ERROR } from "../config/CONSTANTS";
import {
  GET_FORECAST_REPORT,
  SET_DAYS_OF_STOCK,
  SET_LEAD_TIME,
  FORECAST_SETTINGS,
  FORECAST_METAFIELD_DEFINITIONS,
  VARIENT_SETTINGS,
  GET_BASELINE_VELOCITY,
  POST_BASELINE_VELOCITY_BATCH,
  GET_FORECAST_PAGINATED_REPORT,
  REGENERATE_FORECAST_REPORT,
  GET_ALL_LIST,
  GET_FORECAST_LOCATIONS,
  SAVE_FORECAST_LOCATION,
  GET_LOCATION_SWITCH_STATUS,
  GET_FORECAST_DASHBOARD,
  UPDATE_FORECAST_DASHBOARD_STATUS
} from "./CONSTANTS";
import axiosInstance from "../utils/axiosInstance";

export const getForecastReport = (queryparams) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_FORECAST_REPORT(), {
          params: queryparams,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log("getForecastReport > axios err=", err);
          reject("Error in getForecastReport axios!");
        });
    } catch (error) {
      console.error("in forecastServices > getForecastReport, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const setLeadTime = (leadTimeObjects) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(SET_LEAD_TIME(), leadTimeObjects)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in setLeadTime Axios!");
        });
    } catch (error) {
      console.error("in forecastServices > setLeadTime, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const setDaysOfStock = (daysOfStockObjects) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(SET_DAYS_OF_STOCK(), daysOfStockObjects)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in setDaysOfStock Axios!");
        });
    } catch (error) {
      console.error("in forecastServices > setDaysOfStock, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveForecastSettings = (settingObject) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(FORECAST_SETTINGS(), settingObject)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in saving forecast setting Axios!");
        });
    } catch (error) {
      console.error(
        "in forecastServices > saveForecastSettings, Err===",
        error
      );
      reject(SYSTEM_ERROR);
    }
  });
};

export const getForecastSettings = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(FORECAST_SETTINGS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getting forecast setting Axios!");
        });
    } catch (error) {
      console.error("in forecastServices > getForecastSettings, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

/*
 * Fetches the list of Shopify product metafield definitions for the Pack Size dropdown.
 *
 * Returns an array of { label, value } objects where value is "namespace.key".
 * Example: [{ label: "Case Size (custom.case_size)", value: "custom.case_size" }]
 */
export const getMetafieldDefinitions = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(FORECAST_METAFIELD_DEFINITIONS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error fetching metafield definitions");
        });
    } catch (error) {
      console.error("in forecastServices > getMetafieldDefinitions, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

export const setVarientSetting = (dataObj) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(VARIENT_SETTINGS(), dataObj)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in setVarientSetting Axios!");
        });
    } catch (error) {
      console.error("in forecastServices > setVarientSetting, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};



export const getPaginatedForecastData = (queryparams) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_FORECAST_PAGINATED_REPORT(), {
          params: queryparams,
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          console.log("getForecastReport > axios err=", err);
          reject("Error in getForecastReport axios!");
        });
    } catch (error) {
      console.error("in forecastServices > getForecastReport, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};


/*
 * Regenerates the forecast report for the given parameters.
 *
 * Uses POST (not GET) so the variant IDs travel in the request body instead of the
 * URL query string. A GET request packs every variant ID into the URL, and once the
 * selection grows past ~400-500 variants the URL + headers exceed Tomcat's 8 KB
 * maxHttpHeaderSize limit and the server rejects the request before it reaches the
 * controller. The request body has no such limit, so this handles large selections.
 *
 * Note: variantIds is still sent as a comma-separated string (e.g. "123,456,789"),
 * which the backend splits on "," exactly as before.
 */
export const regenerateForecastReport = (queryparams) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(REGENERATE_FORECAST_REPORT(), queryparams)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in regenerateForecastReport Axios!");
        });
    } catch (error) {
      console.error("in forecastServices > regenerateForecastReport, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};


export const getForecastLocations = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_FORECAST_LOCATIONS())
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          console.log("getForecastLocations > axios err=", err);
          reject("Error in getForecastLocations axios!");
        });
    } catch (error) {
      console.error("in forecastServices > getForecastLocations, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Saves the shop's selected/default forecast location.
 * Posts { locationId } to the backend, which sets the default location and
 * (for a real location) kicks off an async inventory re-pull + forecast regen.
 *
 * Example: saveForecastLocation("ALL") or saveForecastLocation("gid://shopify/Location/123")
 */
export const saveForecastLocation = (locationId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(SAVE_FORECAST_LOCATION(), { locationId })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log("saveForecastLocation > axios err=", err);
          reject("Error in saveForecastLocation axios!");
        });
    } catch (error) {
      console.error("in forecastServices > saveForecastLocation, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};


/*
 * Fetches forecast rows for CSV export.
 *
 * POST when variant_ids is present so the IDs travel in the request body instead of
 * the URL query string. A GET packs every variant ID into the URL, and once the
 * selection grows past ~600 variants the URL + headers exceed Tomcat's 8 KB
 * maxHttpHeaderSize limit and the server rejects the request before it reaches the
 * controller. The request body has no such limit, so this handles large selections.
 *
 * Export-all / reorder-today (no variant_ids) stay on GET.
 *
 * Note: variant_ids is still sent as a comma-separated string (e.g. "123,456,789"),
 * which the backend splits on "," exactly as before.
 */
export const getAllForecastList = (params) => {
  return new Promise((resolve, reject) => {
    try {
      const request = params?.variant_ids
        ? axiosInstance.post(GET_ALL_LIST(), params)
        : axiosInstance.get(GET_ALL_LIST(), { params });
      request
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("Error in getAllList Axios!");
        });
    } catch (error) {
      console.error("in forecastServices > getAllList, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

/**
 * Fetches baseline daily sales for the current forecast timeframe, plus
 * auto prior-year BFCM velocity (lastBfcm) for chat planning.
 * Returns null on failure so callers can omit enrichment.
 *
 * options:
 *   { days: 30 }                         // rolling preset (Last 7/14/30/…)
 *   { startDate, endDate }               // custom forecast range (yyyy-MM-dd)
 *   { priorBfcmStartDate, priorBfcmEndDate } // override auto prior BFCM window
 *
 * Example response:
 *   {
 *     variantId: "...",
 *     dailyVelocity: 4.2,
 *     periodDays: 30,
 *     unitsSold: 126,
 *     startDate: "2026-07-12",
 *     endDate: "2026-08-11",
 *     lastBfcm: {
 *       dailyVelocity: 18.5,
 *       periodDays: 7,
 *       unitsSold: 129,
 *       startDate: "2025-11-22",
 *       endDate: "2025-11-28",
 *     },
 *   }
 */
export const getBaselineVelocity = (variantId, options = {}) => {
  return new Promise((resolve) => {
    if (variantId == null || variantId === "") {
      console.log("[baseline-velocity] service skipped — empty variantId");
      resolve(null);
      return;
    }

    const params = { variantId };
    const startDate = options?.startDate;
    const endDate = options?.endDate;
    if (startDate && endDate) {
      params.startDate = startDate;
      params.endDate = endDate;
    } else if (options?.days != null && options.days !== "") {
      params.days = options.days;
    }

    if (options?.priorBfcmStartDate && options?.priorBfcmEndDate) {
      params.priorBfcmStartDate = options.priorBfcmStartDate;
      params.priorBfcmEndDate = options.priorBfcmEndDate;
    }

    const url = GET_BASELINE_VELOCITY();
    console.log("[baseline-velocity] GET", url, params);

    try {
      axiosInstance
        .get(url, { params })
        .then((res) => {
          console.log("[baseline-velocity] GET success", res.status, res.data);
          resolve(res.data ?? null);
        })
        .catch((err) => {
          console.log("getBaselineVelocity > axios err=", err);
          console.log("[baseline-velocity] GET failed", {
            status: err?.response?.status,
            data: err?.response?.data,
            message: err?.message,
          });
          resolve(null);
        });
    } catch (error) {
      console.error("in forecastServices > getBaselineVelocity, Err===", error);
      resolve(null);
    }
  });
};

const BASELINE_VELOCITY_BATCH_MAX = 100;

/**
 * Batch baseline (+ lastBfcm) for many variants (multi-product chatbot).
 * Second arg: days number, or { days } / { startDate, endDate }.
 *
 * Example:
 *   getBaselineVelocitiesBatch(["111", "222"], { days: 14 })
 *   → { periodDays: 14, byVariantId: { "111": { dailyVelocity, lastBfcm, ... } } }
 *
 * @param {string[]} variantIds
 * @param {number | { days?: number | string, startDate?: string, endDate?: string, priorBfcmStartDate?: string, priorBfcmEndDate?: string }} [daysOrOptions]
 * @returns {Promise<{ periodDays: number, byVariantId: Record<string, any> }>}
 */
export const getBaselineVelocitiesBatch = (variantIds, daysOrOptions) => {
  return new Promise((resolve) => {
    const uniqueIds = [
      ...new Set(
        (Array.isArray(variantIds) ? variantIds : [])
          .map((id) => (id == null || id === "" ? null : String(id)))
          .filter(Boolean)
      ),
    ];

    const resolvedOptions =
      daysOrOptions === undefined || daysOrOptions === null ? 30 : daysOrOptions;
    const options =
      resolvedOptions != null && typeof resolvedOptions === "object"
        ? resolvedOptions
        : { days: resolvedOptions };

    const bodyExtras = {};
    if (options.startDate && options.endDate) {
      bodyExtras.startDate = options.startDate;
      bodyExtras.endDate = options.endDate;
    } else if (options.days != null && options.days !== "") {
      bodyExtras.days = options.days;
    } else {
      bodyExtras.days = 30;
    }

    if (options.priorBfcmStartDate && options.priorBfcmEndDate) {
      bodyExtras.priorBfcmStartDate = options.priorBfcmStartDate;
      bodyExtras.priorBfcmEndDate = options.priorBfcmEndDate;
    }

    const fallbackDays = Number(bodyExtras.days) || 30;

    if (!uniqueIds.length) {
      resolve({ periodDays: fallbackDays, byVariantId: {} });
      return;
    }

    const url = POST_BASELINE_VELOCITY_BATCH();
    const chunks = [];
    for (let i = 0; i < uniqueIds.length; i += BASELINE_VELOCITY_BATCH_MAX) {
      chunks.push(uniqueIds.slice(i, i + BASELINE_VELOCITY_BATCH_MAX));
    }

    console.log("[baseline-velocity] POST batch", url, {
      variantCount: uniqueIds.length,
      ...bodyExtras,
    });

    Promise.all(
      chunks.map((chunk) =>
        axiosInstance
          .post(url, { variantIds: chunk, ...bodyExtras })
          .then((res) => {
            console.log("[baseline-velocity] POST batch success", {
              status: res.status,
              resultCount: Array.isArray(res.data?.results)
                ? res.data.results.length
                : 0,
              periodDays: res.data?.periodDays,
              sample: Array.isArray(res.data?.results)
                ? res.data.results[0]
                : null,
            });
            return res.data ?? null;
          })
          .catch((err) => {
            console.error("getBaselineVelocitiesBatch > axios err=", err);
            return null;
          })
      )
    )
      .then((responses) => {
        let periodDays = fallbackDays;
        const byVariantId = {};

        responses.forEach((data) => {
          if (!data || typeof data !== "object") {
            return;
          }
          if (data.periodDays != null) {
            periodDays = data.periodDays;
          }
          (Array.isArray(data.results) ? data.results : []).forEach((row) => {
            if (row?.variantId == null) {
              return;
            }
            byVariantId[String(row.variantId)] = row;
          });
        });

        uniqueIds.forEach((variantId) => {
          if (!byVariantId[variantId]) {
            byVariantId[variantId] = {
              variantId,
              dailyVelocity: 0,
              unitsSold: 0,
            };
          }
        });

        resolve({ periodDays, byVariantId });
      })
      .catch((error) => {
        console.error(
          "in forecastServices > getBaselineVelocitiesBatch, Err===",
          error
        );
        const byVariantId = {};
        uniqueIds.forEach((variantId) => {
          byVariantId[variantId] = {
            variantId,
            dailyVelocity: 0,
            unitsSold: 0,
          };
        });
        resolve({ periodDays: fallbackDays, byVariantId });
      });
  });
};

/**
 * Reads the dedicated location-switch forecast regeneration status.
 * The backend returns { state, timestamp, locationId, inProgress } inside `data`.
 * inProgress is true only while the switch's forecast is still regenerating.
 */
export const getLocationSwitchRegenStatus = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_LOCATION_SWITCH_STATUS())
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          console.log("getLocationSwitchRegenStatus > axios err=", err);
          reject("Error in getLocationSwitchRegenStatus axios!");
        });
    } catch (error) {
      console.error("in forecastServices > getLocationSwitchRegenStatus, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

/*
 * Dashboard homepage payload.
 * Example data:
 *   { onboardingStatus: null, location: { id: "ALL", name: "All Locations" },
 *     counts: { reorderToday: 4, sellsOutIn10Days: 11, overstockedUnits: 86,
 *               overstockedVariants: 5, incomingPos: 3, overduePos: 1 },
 *     timeframe: { label: "Forecast based on the last 30 days of sales" } }
 */
export const getForecastDashboard = () => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(GET_FORECAST_DASHBOARD())
        .then((res) => {
          resolve(res.data?.data);
        })
        .catch((err) => {
          console.log("getForecastDashboard > axios err=", err);
          reject("Error in getForecastDashboard axios!");
        });
    } catch (error) {
      console.error("in forecastServices > getForecastDashboard, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};

/*
 * Updates the one dashboard status row.
 * Example: updateForecastDashboardStatus("dashboard_step2_complete")
 *          → { status: "dashboard_step2_complete", updated: true }
 */
export const updateForecastDashboardStatus = (status) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(UPDATE_FORECAST_DASHBOARD_STATUS(), { status })
        .then((res) => {
          resolve(res.data?.data);
        })
        .catch((err) => {
          console.log("updateForecastDashboardStatus > axios err=", err);
          reject("Error in updateForecastDashboardStatus axios!");
        });
    } catch (error) {
      console.error("in forecastServices > updateForecastDashboardStatus, Err===", error);
      reject(SYSTEM_ERROR);
    }
  });
};
